import { Injectable } from "@angular/core";
import { datadogRum } from "@datadog/browser-rum";
import { UserService } from "./user.service";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root"
})
export class DatadogRumService {
    private initialized = false;

    private getAppVersionFromLicenseKeysCache(): string | undefined {
        try {
            const value = localStorage?.getItem?.("EPRX_APP_VERSION")?.trim?.();
            return value ? value : undefined;
        } catch {
            return undefined;
        }
    }


    isInitialized(): boolean {
        if (this.initialized) return true;

        // Fallback: if something else initialized the SDK, detect it.
        try {
            const getInternalContext = (datadogRum as any)?.getInternalContext;
            if (typeof getInternalContext === "function") {
                return Boolean(getInternalContext.call(datadogRum));
            }
        } catch {
            // ignore
        }

        return false;
    }

    async init(config: any): Promise<void> {
        if (this.isInitialized()) {
            this.initialized = true;
            return;
        }

        try {
            if (!config?.enabled) return;
            if (!config.clientToken || !config.applicationId) return;
            datadogRum.init({
                clientToken: config.clientToken,
                applicationId: config.applicationId,
                site: environment.datadogurl,
                service: window.location.hostname,
                env: config.environment,
                version: this.getAppVersionFromLicenseKeysCache(),
                allowedTracingUrls: [config.allowedTracingUrl],
                sessionSampleRate: 100,
                sessionReplaySampleRate: 100,
                trackUserInteractions: true,
                trackResources: true,
                trackLongTasks: true,
                defaultPrivacyLevel: "allow"
            });

            datadogRum.startSessionReplayRecording();
            this.initialized = true;
        } catch (error) {
            // Never block app startup if RUM config is unavailable
            console.log(`Failed to initialize Datadog RUM: ${error}`);
        }
    }
}
